const cards = [
  {
    title: '锦绣芳华',
    desc: '宫廷权谋与爱恨交织，一部不容错过的年度古装大戏。服化道精良，演员阵容豪华，剧情紧凑不拖沓。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20drama%20scene%20with%20warm%20golden%20and%20orange%20lighting%2C%20silk%20fabrics%20and%20traditional%20architecture%2C%20cinematic%20composition%2C%20soft%20atmospheric%20glow%2C%20minimalist%20poster%20aesthetic%2C%20rich%20textures&width=600&height=400&seq=juzi-card-01&orientation=landscape',
    meta: '古装 · 48集 · 9.6分',
  },
  {
    title: '暗夜追击',
    desc: '扣人心弦的刑侦悬疑剧，高智商犯罪与缜密推理的精彩碰撞，每一个细节都是关键线索。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20crime%20drama%20atmosphere%20with%20warm%20amber%20street%20lights%2C%20noir%20cinematic%20style%2C%20shadow%20and%20light%20contrast%2C%20suspenseful%20mood%2C%20elegant%20dark%20tones%20with%20golden%20accents%2C%20film%20poster%20aesthetic&width=600&height=400&seq=juzi-card-02&orientation=landscape',
    meta: '悬疑 · 36集 · 9.4分',
  },
  {
    title: '春风十里不如你',
    desc: '都市青年的爱情与成长故事，温情治愈中带着生活的真实质感，让无数观众感同身受。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20urban%20drama%20scene%20with%20soft%20sunset%20lighting%2C%20cherry%20blossom%20petals%2C%20modern%20city%20background%2C%20gentle%20orange%20and%20pink%20tones%2C%20cinematic%20bokeh%2C%20elegant%20romantic%20atmosphere&width=600&height=400&seq=juzi-card-03&orientation=landscape',
    meta: '都市 · 40集 · 9.3分',
  },
  {
    title: '大漠孤烟',
    desc: '大气磅礴的历史正剧，还原千年丝路风云。从大漠边疆到朝堂博弈，每一帧都是史诗。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20historical%20drama%20with%20vast%20desert%20landscape%20and%20warm%20golden%20sunset%2C%20ancient%20silk%20road%20atmosphere%2C%20caravans%20in%20distance%2C%20cinematic%20widescreen%20composition%2C%20rich%20orange%20and%20sand%20tones%2C%20dramatic%20sky&width=600&height=400&seq=juzi-card-04&orientation=landscape',
    meta: '历史 · 52集 · 9.1分',
  },
  {
    title: '未来之城 2049',
    desc: '硬核科幻巨制，探讨人工智能时代的伦理与人性。视效震撼，设定严谨，国产科幻新标杆。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cyberpunk%20cityscape%20with%20warm%20neon%20orange%20and%20gold%20accents%2C%20sleek%20architecture%2C%20holographic%20displays%2C%20cinematic%20sci-fi%20aesthetic%2C%20clean%20minimalist%20design%2C%20atmospheric%20fog%20and%20glowing%20lights&width=600&height=400&seq=juzi-card-05&orientation=landscape',
    meta: '科幻 · 30集 · 9.0分',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-tv-2-line text-sm w-4 h-4 flex items-center justify-center"></i>
            精选推荐
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">编辑力推好剧</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">桔子影视编辑团队精心筛选，每部都是口碑与热度兼备的品质好剧。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <div key={card.title} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-background-50/90 text-foreground-700 text-[10px] font-semibold backdrop-blur-sm whitespace-nowrap">{card.meta}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}